export default __webpack_public_path__ + "static/media/LoginBackgound.724beacf.png";